import { Link } from "react-router-dom";
import { ArrowUpRight, ThumbsUp } from "lucide-react";
import { FaqBadges } from "@/components/FaqBadges";
import { sized } from "@/lib/img";

export const FaqCard = ({ faq, index = 0 }) => (
  <Link
    to={`/faq/${faq.slug}`}
    data-testid={`faq-card-${faq.slug}`}
    style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    className="rise group grid grid-cols-[96px_1fr] sm:grid-cols-[220px_1fr] bg-[#13171F] border border-[#27303E] hover:border-amber-500/70 active:bg-[#1A202C] rounded-sm overflow-hidden transition-colors duration-200"
  >
    <div className="relative min-h-[112px] sm:h-full overflow-hidden">
      <img src={sized(faq.image, 600)} alt={faq.question} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
    </div>
    <div className="p-3.5 sm:p-6 flex flex-col gap-2 sm:gap-3 min-w-0">
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display text-lg sm:text-2xl font-bold uppercase leading-tight tracking-tight group-hover:text-amber-400 transition-colors duration-200">
          {faq.question}
        </h3>
        <ArrowUpRight className="hidden sm:block shrink-0 text-slate-500 group-hover:text-amber-500 transition-colors duration-200" />
      </div>
      <p className="hidden sm:block text-slate-400 text-sm leading-relaxed line-clamp-2">{faq.summary}</p>
      <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-3 mt-auto">
        <FaqBadges faq={faq} compact />
        <span className="hidden sm:inline-flex items-center gap-1 font-mono text-xs text-slate-500">
          <ThumbsUp size={12} /> {faq.helpful_yes} found helpful
        </span>
      </div>
    </div>
  </Link>
);
